<template>
  <div class="body-1" v-if="!isOwner">Pídele al dueño de la cuenta que actualice su plan.</div>
  <v-btn small rounded color="primary" v-else @click="onClick"
  >Contrata un nuevo plan</v-btn>
</template>

<script>

import {mapGetters} from 'vuex'

export default {
  name: "BuyNewPlanBtn",
  computed:{
    ...mapGetters(['isOwner', 'isAdmin']),
  },
  methods:{
    onClick(){
      const vm = this
      const isSettingsScreen = vm.$route.path === '/panel/provider/settings'
      vm.$router.push({
        name: 'panel.provider.settings',
        query: {
          view: 'SubscriptionSettings',
        }
      })

      if(isSettingsScreen){
        window.location.reload()
      }

    }
  }
}
</script>

<style scoped>

</style>
